// Lib
import React, { MutableRefObject } from 'react';
import { useSelector } from 'react-redux';
import { getIsFeatureEnabledForCurrentUser } from '../feature/elementFeatureSelector';
import Handsontable from 'handsontable';
import HotTable from './HotTable';
import LegacyHotTable from './legacy/HotTable';
import { TranslationFunction } from '../../components/i18n/types';
import { ExperimentId } from '../../../common/experiments/experimentsConstants';

import './HotTableSwitch.scss';

type HotTableSwitchProps = {
    hotTableInstanceRef: MutableRefObject<Handsontable | null>;
    hotTableContainerRef: MutableRefObject<HTMLDivElement>;
    showTitle: boolean;
    showCaption: boolean;
    isReadOnly: boolean;
    isGridMoving: boolean;
    setIsGridMoving: (isMoving: boolean) => void;
    translateTableContextMenu: TranslationFunction;
};

const HotTableSwitch: React.FC<HotTableSwitchProps> = (props) => {
    const isTableDataV2Enabled = useSelector(getIsFeatureEnabledForCurrentUser(ExperimentId.tableArchV2));

    if (isTableDataV2Enabled) {
        return <HotTable {...props} />;
    }

    return <LegacyHotTable {...props} />;
};

export default HotTableSwitch;
